// Mixins
import AppPage from '../../mixins/app-page'

// Components
import AppNewsletter from '../app-newsletter'
import AppTextLinesSeparated from '../app-text-lines-separated'

// Utils
import getAbsoluteBoundingRect from '../../utils/getAbsoluteBoundingRect'
import { clamp } from '../../utils/Number'

export default
{
    name: 'page-about',

    mixins:
    [
        AppPage
    ],

    components:
    {
        AppNewsletter,
        AppTextLinesSeparated
    },

    data()
    {
        return {
            content: this.$root.content.contact,
            recognitions: [],
            buttonBackToTopIsVisible: false
        }
    },

    created()
    {
        // Variables
        this.recognitions = this._getSplittedRecognitions()

        // Get events
        this.eventHub.$on('window:resize', this._onResize)
        this.eventHub.$on('window:raf', this._onEnterFrame)
        this.eventHub.$on('application:keydown', this._onKeydown)
    },

    mounted()
    {
        this.eventHub.$emit('app-header:change-color', 'white')
        this.eventHub.$emit('page:enable-scroll')
        this.eventHub.$emit('app-header:show-header')

        this.$containerContacts = this.$el.querySelector('.js-contacts-container')
        this.$containerContactsMobile = this.$el.querySelector('.js-contact-mobile')
        this.$containerInformations = this.$el.querySelector('.js-informations-container')
        this.$title = this.$el.querySelector('.js-title')
        this.$firstContent = this.$el.querySelector('.js-first-content')

        this._onResize()
    },

    destroyed()
    {
        // Destroy events
        this.eventHub.$off('window:resize', this._onResize)
        this.eventHub.$off('window:raf', this._onEnterFrame)
        this.eventHub.$off('application:keydown', this._onKeydown)
    },

    methods:
    {
        // EVENTS
        _onEnterFrame()
        {
            this.buttonBackToTopIsVisible = this.$root.smoothScroll >= this.$root.height
        },

        _onKeydown(event)
        {
            if (event.keyCode === 27)
            {
                this._closePage()
            }
        },

        _onResize()
        {
            if (this.$el)
            {
                this._elRect = getAbsoluteBoundingRect(this.$el)
            }

            if (this.$containerContacts)
            {
                this._containerContactsRect = getAbsoluteBoundingRect(this.$containerContacts)
            }

            if (this.$containerContactsMobile)
            {
                this._containerContactsMobileRect = getAbsoluteBoundingRect(this.$containerContactsMobile)
            }

            if (this.$containerInformations)
            {
                this._containerInformationsRect = getAbsoluteBoundingRect(this.$containerInformations)
            }

            if (this.$title)
            {
                this._titleRect = getAbsoluteBoundingRect(this.$title)
            }

            if (this.$firstContent)
            {
                this._firstContentRect = getAbsoluteBoundingRect(this.$firstContent)
            }

            if (this._containerContactsRect
                && this._containerInformationsRect
                && this._titleRect
                && this._firstContentRect)
            {
                const maxHeight = Math.max(this._containerContactsRect.height, this._containerInformationsRect.height)

                const positionTop = this.$root.height - maxHeight - 70

                this.$containerContacts.style.top = `${positionTop}px`
                this.$containerInformations.style.top = `${positionTop}px`

                const marginTop = this.$root.width > this.$root.breakpoints.lg ? clamp(positionTop - this._titleRect.height - this._firstContentRect.margins.top, 0, this.$root.height / 100 * 50) : this.$root.height / 100 * 50

                this.$title.style.marginTop = `${marginTop}px`
            }
        },

        // ACTIONS
        _closePage()
        {
            this.$router.push(this.$root.getPageURLFromName('home'))
        },

        // HTML ACTIONS
        _clickOnButtonContactUs()
        {
            if (this._containerContactsMobileRect) this.$root.scrollTo(this._containerContactsMobileRect.top)
        },

        _clickOnButtonBackToTop()
        {
            this.$root.scrollTo(0)
        },

        // GETTERS
        _getSplittedRecognitions()
        {
            const recognitions = this.$root.content.recognitions.entries
            const recognitionsSplitted = []
            const numberPerColumn = 6

            for (let i = 0; i < recognitions.length; i += 1)
            {
                const recognition = recognitions[i]
                const array = []

                if (recognition.entity) array.push(`${recognition.entity.title} x`)
                if (recognition.amount) array.push(recognition.amount)
                if (recognition.title) array.push(recognition.title)

                recognition.text = array.join(' ')

                if (!recognitionsSplitted[Math.floor(i / numberPerColumn)])
                {
                    recognitionsSplitted[Math.floor(i / numberPerColumn)] = []
                }
                recognitionsSplitted[Math.floor(i / numberPerColumn)].push(recognition)
            }

            return recognitionsSplitted
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-about/script.js